// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'merge';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M9 10.607a6.83 6.83 0 0 1-6.83 6.83m13.66.001A6.83 6.83 0 0 1 9 10.608m0-.001V.563M4.178 5.384 9 .562l4.822 4.822'
  />
);

export const viewBox = '0 0 18 18';
